import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

export default class StatusCellRenderer extends Component {
    render() {
        const { value } = this.props;
        
        let variant = 'secondary';
        let displayText = value;
        
        switch (value) {
            case 'active':
                variant = 'success';
                displayText = 'Active';
                break;
            case 'discontinued':
                variant = 'danger';
                displayText = 'Discontinued';
                break;
            case 'suspended':
                variant = 'warning';
                displayText = 'Suspended';
                break;
            case 'completed':
                variant = 'info';
                displayText = 'Completed';
                break;
            default:
                variant = 'secondary';
                displayText = value || 'Unknown';
        }
        
        return (
            <Badge variant={variant}>
                {displayText}
            </Badge>
        );
    }
}